import { Component, ViewChild, inject } from '@angular/core';
import { DxValidationGroupComponent, DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationSharedService } from '../registration-shared.service';
import { AnalyticsService } from '../../shared/analytics.service';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';
import { TextFieldComponent } from '@pedix-workspace/angular-ui-form';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-step-account',
    templateUrl: './step-account.component.html',
    styleUrls: ['./step-account.component.scss'],
    imports: [
        TranslocoDirective,
        DxValidationGroupModule,
        TextFieldComponent,
        ButtonComponent,
    ]
})
export class StepAccountComponent {
  usernamePattern = /^[a-z0-9.\-_]+$/i;
  buttonNextText;

  @ViewChild('validationGroup') validationGroup: DxValidationGroupComponent;

  private toastrService = inject(ToastrService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private analyticsService = inject(AnalyticsService);
  public registrationSharedService = inject(RegistrationSharedService);
  private t = inject(TranslocoService);
  
  constructor() {
    this.buttonNextText = this.t.translate('general.next');
  }

  async validateStepAndContinue($event) {
    $event.preventDefault();

    if (!this.validationGroup.instance.validate().isValid) {
      this.toastrService.error(this.t.translate('general.error'));

      return;
    }

    this.registrationSharedService.registrationData.account.email = `${this.registrationSharedService.registrationData.account.username}@${environment.emailDomain}`;

    this.router.navigate(['../payment'], { relativeTo: this.activatedRoute });
  }

  prev() {
    this.analyticsService.previousStep('establishment');
    this.router.navigate(['../establishment'], {
      relativeTo: this.activatedRoute,
    });
  }
}
